<template>
  <main class="single-page">
    <div class="col-2">
      <h1>Wyszukiwanie zaawansowane</h1>
      <div v-if="null">
        <img
          v-if="this.$parent.page.ckc_cover_image"
          :src="this.$parent.page.ckc_cover_image"
          alt=""
        />
        <img v-else src="~@/assets/img/default.png" alt="" />
      </div>
      <div class="text-up" style="margin-bottom: 30px">
        <div class="form" id="advanced-search-form">
          <form>
            <div id="search-keywords" class="field">
              <div class="two columns alpha">
                <label for="keyword-search">Wyszukaj słów</label>
              </div>
              <div class="five columns omega inputs">
                <input
                  type="text"
                  name="search"
                  id="keyword-search"
                  size="40"
                  aria-placeholder="Wpisz wyszukiwaną frazę"
                  :placeholder="'Wpisz wyszukiwaną frazę'"
                  v-model="advanced.search"
                />
                <div class="search-functions" v-if="this.advanced.search">
                  <div class="remove_search">
                    <a @click="cleanSearch">&#8722; Wyczyść to pole</a>
                  </div>
                </div>
              </div>
            </div>
            <div id="search-narrow-by-fields" class="field">
              <div class="two columns alpha label">
                <label>Ogranicz do określonych pól</label>
              </div>
              <div class="five columns omega inputs">
                <div
                  class="search-entry"
                  v-for="(s, i) in advanced.searches"
                  :key="i"
                >
                  <select
                    @change="searchesChanged()"
                    :name="'advanced[' + i + '][joiner]'"
                    id=""
                    title="Search Joiner"
                    class="advanced-search-joiner"
                    v-model="advanced.searches[i].joiner"
                    v-if="i != 0"
                  >
                    <option value="and">ORAZ</option>
                    <option value="or">LUB</option></select
                  ><select
                    :name="'advanced[' + i + '][element_id]'"
                    @change="searchesChanged()"
                    id=""
                    title="Pole wyszukiwania"
                    class="advanced-search-element"
                    v-model="advanced.searches[i].element_id"
                  >
                    <option value="">Zaznacz poniżej</option>
                    <optgroup id="-optgroup-Dublin Core" label="Dublin Core">
                      <option value="50">Tytuł</option>
                      <option value="41">Opis</option>
                      <option value="40">Data</option>
                      <option value="39">Twórca</option>
                      <option value="47">Prawa</option>
                      <option value="51">Typ</option>
                      <option value="44">Język</option>
                      <option value="42">Format</option>
                      <option value="43">Identyfikator</option>
                      <option value="37">Współtwórca</option>
                      <option value="48">Źródło</option>
                      <option value="38">Zasięg</option>
                      <option value="46">Relacja</option>
                      <option value="49">Temat</option>
                    </optgroup>
                    <optgroup
                      id="-optgroup-Metadane typu publikacji"
                      label="Metadane typu publikacji"
                    >
                      <option value="68">Lokalizacja</option>
                      <option value="69">Własność</option>
                      <option value="81">Darczyńca</option>
                      <option value="67">Format Źródła</option>
                      <option value="52">Nazwisko i imię</option>
                      <option value="53">Data urodzenia</option>
                      <option value="54">Data śmierci</option>
                      <option value="55">Miejsce urodzenia</option>
                      <option value="56">Miejsce śmierci</option>
                      <option value="57">Miejsce pochówku</option>
                      <option value="58">Stopnie i tytuły</option>
                      <option value="59">
                        Stanowiska i funkcje na Wydziale Fizyki
                      </option>
                      <option value="66">Bibliografia</option>
                      <option value="62">Źródło</option>
                      <!-- <option value="77">Nazwa eksponatu</option>
                      <option value="75">Rozmiar źródła</option>
                      <option value="76">Lokalizacja zdarzenia</option>
                      <option value="80">nowe pole do wypełnienia</option>
                      <option value="78">Autor i data wpisu</option>
                      <option value="79">Wymiary eksponatu</option>
                      <option value="83">Data utworzenia</option>
                      <option value="82">Próba nowy atrybut</option>
                      <option value="74">kolekcja</option>
                      <option value="73">Sygnatura</option>
                      <option value="65">Data wpisu</option>
                      <option value="64">Autor wpisu</option>
                      <option value="63">Identyfikator</option>
                      <option value="71">Tytuł</option>
                      <option value="60">Instytucje powiązane</option>
                      <option value="61">Biogram</option>
                      <option value="33">Death Date</option>
                      <option value="70">Data2</option>
                      <option value="72">Opis</option>
                      <option value="84">Typ fotografii</option>
                      <option value="13">Realizator</option>
                      <option value="18">Subject Line</option>
                      <option value="17">Email Body</option>
                      <option value="16">Time Summary</option>
                      <option value="15">Bit Rate/Frequency</option>
                      <option value="14">Director</option>
                      <option value="12">Kompresja</option>
                      <option value="11">Czas trwania</option>
                      <option value="10">Physical Dimensions</option>
                      <option value="7">Original Format</option>
                      <option value="6">Local URL</option>
                      <option value="5">Transcription</option>
                      <option value="4">Location</option>
                      <option value="3">Interviewee</option>
                      <option value="2">Interviewer</option>
                      <option value="19">From</option>
                      <option value="20">To</option>
                      <option value="21">CC</option>
                      <option value="36">Bibliography</option>
                      <option value="35">Biographical Text</option>
                      <option value="34">Occupation</option>
                      <option value="32">Birthplace</option>
                      <option value="31">Birth Date</option>
                      <option value="30">Participants</option>
                      <option value="29">Event Type</option>
                      <option value="28">Odnośnik internetowy</option>
                      <option value="27">Lesson Plan Text</option>
                      <option value="26">Materials</option>
                      <option value="25">Objectives</option>
                      <option value="24">Standards</option>
                      <option value="23">Number of Attachments</option>
                      <option value="22">BCC</option>
                      <option value="1">Tekst</option> -->
                    </optgroup></select
                  ><select
                    :name="'advanced[' + i + '][type]'"
                    id=""
                    title="Typ wyszukiwania"
                    class="advanced-search-type"
                    v-model="advanced.searches[i].type"
                    @change="searchesChanged()"
                  >
                    <option value="" selected="selected">
                      Zaznacz poniżej
                    </option>
                    <option value="contains">zawiera</option>
                    <option value="does not contain">nie zawiera</option>
                    <option value="is exactly">zawiera dokładnie</option>
                    <option value="is not exactly">nie jest dokładnie</option>
                    <option value="is empty">jest pusty</option>
                    <option value="is not empty">nie jest pusty</option>
                    <option value="starts with">zaczyna się od</option>
                    <option value="ends with">kończy się na</option>
                    <option value="matches">zawiera</option>
                    <option value="does not match">
                      nie zawiera
                    </option></select
                  ><input
                    @change="searchesChanged()"
                    type="text"
                    :name="'advanced[' + i + '][terms]'"
                    id=""
                    value=""
                    size="40"
                    title="Terminy wyszukiwawcze"
                    class="advanced-search-terms"
                    aria-placeholder="Wpisz wyszukiwaną frazę"
                    :placeholder="'Wpisz wyszukiwaną frazę'"
                    v-model="advanced.searches[i].terms"
                  />
                  <div class="search-functions">
                    <div
                      class="remove_search"
                      v-if="advanced.searches.length > 1"
                    >
                      <a @click="removeSearchCondition(i)"
                        >&#8722; Usuń ten warunek</a
                      >
                    </div>
                    <div
                      class="add_search"
                      v-if="
                        i == advanced.searches.length - 1 &&
                        advanced.searches.length <= 3
                      "
                    >
                      <a @click="addMoreSearchConditions()"
                        >&#43; Dodaj kolejny warunek</a
                      >
                    </div>
                    <div
                      class="add_search disabled"
                      v-if="
                        i == advanced.searches.length - 1 &&
                        advanced.searches.length > 3
                      "
                    >
                      <a disabled
                        >Zbyt wiele warunków wyszukiwania może uniemożliwić
                        znalezienie czegokolwiek.</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="search-selects">
              <div class="field">
                <div class="two columns alpha">
                  <label for="collection-search">Kolekcja</label>
                </div>
                <div class="five columns omega inputs">
                  <select
                    name="collection"
                    id="collection-search"
                    @change="selectCollection"
                  >
                    <option value="">Zaznacz poniżej</option>
                    <option
                      v-for="(c, i) in collections"
                      :key="i"
                      :value="c.id"
                    >
                      {{ c.title }} ({{ c.count }})
                    </option>
                  </select>
                </div>
              </div>

              <div class="field">
                <div class="two columns alpha">
                  <label for="item-type-search">Typ publikacji</label>
                </div>
                <div class="five columns omega inputs">
                  <select
                    name="type"
                    id="item-type-search"
                    @change="selectType"
                  >
                    <option value="">Zaznacz poniżej</option>
                    <option value="18">Biogram</option>
                    <option value="19">Dokument</option>
                    <option value="24">Eksponat</option>
                    <option value="20">Fotografia</option>
                  </select>
                </div>
              </div>
              <div class="field">
                <div class="two columns alpha">
                  <label for="tag-search">Zawiera etykiety</label>
                </div>
                <div :class="tags_class">
                  <span
                    v-for="(t, i) in tags"
                    :key="i"
                    :title="'Wybierz etykietę -- ' + t.name + ' --'"
                    @click="selectTag"
                    :class="'tag-' + t.id"
                    >{{ t.name }}</span
                  >
                </div>
                <div class="five columns omega inputs">
                  <input
                    type="text"
                    name="tags"
                    id="tag-search"
                    :value="this.advanced.tag"
                    size="40"
                    disabled
                    aria-placeholder="Wpisz wyszukiwaną frazę"
                    :placeholder="'Wpisz wyszukiwaną frazę'"
                  />
                </div>
                <div class="tags-functions" v-if="this.advanced.tag">
                  <div class="remove_tag">
                    <a @click="cleanTag">&#8722; Usuń ten warunek</a>
                  </div>
                </div>
              </div>
              <div class="field button-field" v-if="!this.results">
                <button @click.prevent="buildAdvancedQuery()">Wyszukaj</button>
              </div>
              <div class="field button-field results" v-if="this.results">
                <div v-if="this.results.total > 0" class="results_information">
                  {{
                    this.results.total +
                    " " +
                    polishPlurals(
                      "OBIEKT",
                      "OBIEKTY",
                      "OBIEKTÓW",
                      this.results.total
                    )
                  }}
                </div>
                <div v-if="this.results.total == 0" class="results_information">
                  Niczego nie znaleziono. Edytuj kwerendę.
                </div>
                <button
                  v-if="this.results.total > 0 && null"
                  @click.prevent="showResults()"
                >
                  Pokaż wyniki
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="icon-links to-right">
          <a v-if="null" :href="this.$parent.fbShareURL"
            ><i class="icon-fb"></i
          ></a>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import NProgress from "nprogress";

export default {
  name: "AdvancedSearchContent",
  props: ["tags", "collections"],
  components: {},
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      tags_class: "all_tags",
      advanced: {
        tag: null,
        type: null,
        collection: null,
        search: null,
        searches: [{ terms: null, joiner: "and", element_id: "", type: "" }],
        query_uri: null,
      },
      advanced_json: null,
      results: null,
    };
  },
  methods: {
    selectTag(e) {
      this.tags_class = "all_tags hide_all";
      this.advanced.tag = e.target.outerText;
      // Firefox :
      if (typeof e.target.outerText === "undefined")
        this.advanced.tag = e.target.textContent.toUpperCase();
      this.advanced_json = JSON.stringify(this.advanced);
    },
    cleanTag() {
      this.tags_class = "all_tags";
      this.advanced.tag = null;
      this.advanced_json = JSON.stringify(this.advanced);
    },
    cleanSearch() {
      this.advanced.search = null;
      this.advanced_json = JSON.stringify(this.advanced);
    },
    selectType(e) {
      this.advanced.type = Number(e.target.value);
      if (this.advanced.type == "") this.advanced.type = null;
      this.advanced_json = JSON.stringify(this.advanced);
    },
    selectCollection(e) {
      this.advanced.collection = Number(e.target.value);
      if (this.advanced.type == "") this.advanced.collection = null;
      this.advanced_json = JSON.stringify(this.advanced);
    },
    selectJoiner(i, e) {
      this.advanced.searches[i].joiner = Number(e.target.value);
      if (this.advanced.searches[i].joiner == "")
        this.advanced.searches[i].joiner = null;
    },
    searchesChanged() {
      this.advanced_json = JSON.stringify(this.advanced);
    },
    addMoreSearchConditions() {
      let _this = this;
      // id nie jest wazne
      this.advanced.searches.push({
        terms: null,
        joiner: "and",
        element_id: "",
        type: "",
      });
      this.advanced_json = JSON.stringify(this.advanced);
    },
    removeSearchCondition(f) {
      this.advanced.searches.splice(f, 1);
      this.advanced_json = JSON.stringify(this.advanced);
    },
    buildAdvancedQuery() {
      // search=QUERY&advanced[0][joiner]=and&advanced[0][element_id]=46&advanced[0][type]=contains&advanced[0][terms]=

      this.advanced.query_uri = "items";

      // 1. add search= without & on the end
      if (this.advanced.search) {
        this.advanced.query_uri =
          this.advanced.query_uri + "?search=" + this.advanced.search;
      } else {
        this.advanced.query_uri = this.advanced.query_uri + "?search=";
      }

      // 2. build advanced

      let _advanced = [];

      if (this.advanced.searches[0].terms) {
        this.advanced.searches.forEach((_a, i) => {
          let _s =
            "&advanced[" +
            i +
            "][joiner]=" +
            _a.joiner +
            "&advanced[" +
            i +
            "][element_id]=" +
            _a.element_id +
            "&advanced[" +
            i +
            "][type]=" +
            _a.type +
            "&advanced[" +
            i +
            "][terms]=" +
            _a.terms;
          _advanced.push(_s);
        });

        // add advanced to uri

        this.advanced.query_uri = this.advanced.query_uri + _advanced.join("");
      }

      // add other parameters (if)

      if (this.advanced.collection)
        this.advanced.query_uri =
          this.advanced.query_uri + "&collection=" + this.advanced.collection;
      if (this.advanced.tag)
        this.advanced.query_uri =
          this.advanced.query_uri + "&tags=" + this.advanced.tag;
      if (this.advanced.type)
        this.advanced.query_uri =
          this.advanced.query_uri + "&item_type=" + this.advanced.type;

      this.previewResults();
    },
    showResults() {
      let _this = this;
      // fix!!
      this.$router.push({
        name: "Search",
        params: {
          query: encodeURI("___" + this.advanced.query_uri),
          advanced: true,
          apiCall: this.advanced.query_uri,
        },
      });
    },
    previewResults() {
      // preview
      NProgress.start();
      axios
        .get(this.$config.API_PATH + this.advanced.query_uri)
        .then((_resp) => {
          this.results = {
            total: _resp.headers["omeka-total-results"],
            data: _resp.data,
          };
        })
        .then(() => {
          NProgress.done();
          // redirect if something is found
          if (this.results.total > 0) this.showResults();
        });
    },
  },
  destroyed() {},
  mounted: function () {},
  watch: {
    "advanced.tag": function (e) {
      //this.previewResults()
      this.advanced_json = JSON.stringify(this.advanced);
    },
    "advanced.type": function (e) {
      this.advanced_json = JSON.stringify(this.advanced);
    },
    "advanced.collection": function (e) {
      this.advanced_json = JSON.stringify(this.advanced);
    },
    "advanced.search": function () {
      if (this.advanced.search == "") this.advanced.search = null;
      this.advanced_json = JSON.stringify(this.advanced);
    },
    "advanced.searches": function (a, b) {
      // not used because of searchesChanged()
      this.advanced_json = JSON.stringify(this.advanced);
    },
    "advanced.tag": function (a, b) {},
    advanced_json: function () {
      // reset results and buttons
      this.results = null;
    },
  },
};
</script>

<style scoped>
.col-2 > div {
  width: 100%;
}

/* form css */

#advanced-search-form {
  margin: 2em;
}

form select {
  padding: 0.5625rem 0.75rem;
  display: block;
  margin-bottom: 1em;
}

#advanced-search-form div {
  margin-top: 1em;
}

.field {
  border: 1px solid #465165;
  padding: 1em;
}

.button-field {
  text-align: right;
  font-size: 2.375rem;
}

button {
  text-transform: uppercase;
  padding: 5px;
}

button:hover {
  background-color: #c63;
  cursor: pointer;
}

.search-functions,
.tags-functions {
  display: flex;
  justify-content: space-between;
}

.search-functions a,
.tags-functions a {
  cursor: pointer;
}

.add_search {
}

#advanced-search-form a {
  color: #c63;
}

#advanced-search-form label {
  text-transform: uppercase;
  font-weight: bold;
}

.all_tags span {
  font-size: 0.7em;
  display: inline-block;
  padding: 5px;
  background: #465165;
  margin: 5px;
  text-transform: uppercase;
}

.all_tags span {
  color: #fff;
}

.all_tags span:hover {
  color: #c63;
  cursor: pointer;
}

.all_tags,
.results {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.hide_all {
  display: none;
}

.disabled a {
  cursor: default;
}

.results {
  align-items: baseline;
}
</style>



// WEBPACK FOOTER //
// src/components/AdvancedSearch/AdvancedSearchContent.vue